import { memo, useMemo, type FC } from 'react';
import { useTheme } from 'styled-components';

import { Dot } from './styled.ts';
import type { NotificationIndicatorProps } from './types.ts';

export type { NotificationIndicatorProps } from './types.ts';

export const NotificationIndicator: FC<NotificationIndicatorProps> = memo(function NotificationIndicator({
  positive,
  warning,
  critical,
  className,
  dataTestId,
}) {
  const { colors } = useTheme();

  const color = useMemo(() => {
    if (critical) return colors.critical100;
    if (warning) return colors.warning100;
    if (positive) return colors.positive100;
    return colors.grey30_1;
  }, [colors, critical, warning, positive]);

  return <Dot className={className} $color={color} data-testid={dataTestId} />;
});
